import { connect } from 'react-redux';

import {
  addFilterClause,
  removeFilterClause,
  setClausesConcatOperator,
  setFilterClauseOperator,
  setFilterClauseField,
  setFilterClauseValue,
} from '../../../../../actions/dashboards/funnels';
import { getMetainf, getProjectZoneId } from '../../../../../reducers/analyticsApp';
import FilterContainer from '../../../../../components/filter/FilterContainer';

const mapStateToProps = (state, { event, filter }) => ({
  concatOperator: filter.concatOperator,
  clauses: filter.clauses,
  metainf: getMetainf(state, event),
  zoneId: getProjectZoneId(state),
});

const mapDispatchToProps = (dispatch, { stepIndex, unit }) => ({
  onSetClausesConcatOperator: (value) =>
    dispatch(setClausesConcatOperator(stepIndex, value, unit?.id)),
  onAddFilterClause: () => dispatch(addFilterClause(stepIndex, unit?.id)),
  onRemoveFilterClause: (id) => dispatch(removeFilterClause(stepIndex, id, unit?.id)),
  onSelectFilterClauseField: (id, field, type) =>
    dispatch(setFilterClauseField(stepIndex, id, field, type, unit?.id)),
  onSelectFilterClauseOperator: (id, value, resetClauseValue) =>
    dispatch(setFilterClauseOperator(stepIndex, id, value, resetClauseValue, unit?.id)),
  onFilterClauseValueChange: (id, value) =>
    dispatch(setFilterClauseValue(stepIndex, id, value, unit?.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterContainer);
